import React from 'react';
import style from './index.less';
import {Form,Button} from 'antd';
const FormItem = Form.Item;

class FilterForm extends React.Component {

    render(){
        return (
            <div className={style.form}>
                <Form {...this.props}>
                    {this.props.children}
                    <FormItem>
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={this.props.disabledSubmit}
                        >
                            Query
                        </Button>
                    </FormItem>
                </Form>
            </div>
        );
    }
};

export default FilterForm;



// WEBPACK FOOTER //
// ./src/components/FilterForm/index.js